export const mixin = {
  data() {
    return {
      // 客户端传来的等级数据
      // hostessGrade: this.$route.query.hostessGrade || 2,
      // 背景图list
      levelBgList: {
        1: require('@/assets/packageAssets/views/P1_Girls/HostessCenter/default/level_bg_off.png'),
        2: require('@/assets/packageAssets/views/P1_Girls/HostessCenter/default/level_bg_on.png'),
        3: require('@/assets/packageAssets/views/P1_Girls/HostessCenter/default/level_bg_on.png'),
        4: require('@/assets/packageAssets/views/P1_Girls/HostessCenter/default/level_bg_on.png'),
      },
      // 徽章背景图list
      levelBadgeList: {
        1: require('@/assets/packageAssets/views/P1_Girls/HostessCenter/default/level_off.png'),
        2: require('@/assets/packageAssets/views/P1_Girls/HostessCenter/default/level_on.png'),
        3: require('@/assets/packageAssets/views/P1_Girls/HostessCenter/default/level_on.png'),
        4: require('@/assets/packageAssets/views/P1_Girls/HostessCenter/default/level_on.png'),
      },
    }
  },
}
